import {
    Component,
    HostListener,
    Input,
    OnChanges,
    SimpleChanges,
    ElementRef,
    ViewChild,
    AfterViewInit,
} from "@angular/core";
import Chart from "chart.js/auto";
import { ChartJsData } from "../../../models/ChartJsDataset";
import { Guid } from "../../../models/Guid";

@Component({
    selector: "app-line-chart",
    template: `
        <div
            class="chart-container"
            style="position: relative; height:60vh; width:80vw"
        >
            <canvas [attr.id]="id" #chartCanvas>{{ chart }}</canvas>
        </div>
    `,
    styles: [],
    standalone: false
})
export class LineChartComponent implements AfterViewInit, OnChanges {
    @HostListener("window:beforeprint", ["$event"])
    onBeforePrint() {
        this.chart.resize(900, 600);
    }

    @HostListener("window:afterprint", ["$event"])
    onAfterPrint() {
        this.chart.resize();
    }

    @Input() data: ChartJsData | undefined = undefined;
    @Input() yLabel: string | undefined = ""
    @Input() xLabel: string | undefined = ""
    @ViewChild("chartCanvas", {static: false}) chartCanvasRef: ElementRef | undefined;

    id: string = Guid.newGuid();
    isInitialized: boolean = false;

    constructor() {}

    ngAfterViewInit(): void {
        if (this.data) {
            this.isInitialized = true;
            setTimeout(()=>{
                this.createChart();
            }, 0);

        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["data"] && this.isInitialized) {
            this.createChart();
        }
    }

    public chart: any | undefined;

    createChart() {
        if (!this.data) {
            return;
        }

        if (this.chart) {
            this.chart.destroy();
        }

        let htmlRef = this.chartCanvasRef?.nativeElement;

        console.debug(this.data);

        this.chart = new Chart(htmlRef, {
            type: "line",
            data: this.data,
            options: {
                animation:false,
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                        title: {
                            display: true,
                            text: this.xLabel
                        }
                    },
                    y: {
                        stacked: true,
                        suggestedMin: -1000,
                        suggestedMax: 1000,
                        title: {
                            display: true,
                            text: this.yLabel
                        }
                    }
                },
                locale: "da-DK",
            },
        });
    }
}
